import React, { useState } from "react";
import "./PolicyNotTreeTable.less";
import { Col, Row, Table, Tooltip, Tree } from "antd";
import { TableColumn } from "../../../../lib/interfaces";
import { Offer } from "../../../../lib/types";
import { toDisplayFormat } from "../../../../lib/utils";
import dots from "../../../../img/3dots.svg";

const columnsWidths: Partial<Record<keyof Offer, string>> = {
  extName: "29%",
  name: "50%",
  fromDate: "270px",
};

interface ComponentProps {
  offer?: Offer;
  handleShowHistoryModal: (record) => void;
}

export const PolicyNotTreeTable = ({ offer, handleShowHistoryModal }: ComponentProps) => {
  const tableData = offer ? [offer] : [];

  const getOfferColumns = (): TableColumn<Offer>[] => {
    return [
      {
        title: "Наименование",
        key: "extName",
        dataIndex: "extName",
        width: columnsWidths.extName,
        hidden: false,
      },
      {
        title: (
          <Row justify="center">
            <Tooltip title="умолч | мин | макс">Количество</Tooltip>
          </Row>
        ),
        key: "id",
        dataIndex: "id",
        width: columnsWidths.name,
        hidden: false,
        render: (_) => {
          return null;
        },
      },

      {
        title: "Период",
        dataIndex: "id",
        key: "id",
        width: columnsWidths.fromDate,
        hidden: false,
        render: (_, record) => {
          return `${record?.fromDate && toDisplayFormat(record?.fromDate)} - ${
            record?.toDate && toDisplayFormat(record?.toDate)
          }`;
        },
      },

      {
        dataIndex: "btns",
        key: "btns",
        width: "42px",
        style: { padding: "10px" },
        render: (_, record) => (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleShowHistoryModal(record);
            }}
            className="button-icon"
            style={{
              boxShadow: "none",
              border: 0,
              marginLeft: "-10px",
              outline: "none",
              cursor: "pointer",
            }}
            type="button"
          >
            <img src={dots} alt="dots" />
          </button>
        ),
      },
    ];
  };

  const [columns, setColumns] = useState<TableColumn<Offer>[]>(getOfferColumns());

  return (
    <Row className="policy-not-tree">
      <Col span={24}>
        <Table
          size="small"
          columns={columns.filter(({ hidden }) => !hidden)}
          dataSource={tableData}
          pagination={false}
        />
      </Col>
    </Row>
  );
};

export default PolicyNotTreeTable;
